export default {
    'export': 'تصدير',
    'export-as-excel': 'تصدير إكسل',
    'print-materials-tree': 'طباعة شجرة المواد',
    warehouse: 'المستودع',
    'material-name-or-no': 'رقم أو اسم المادة',
    'add': 'إضافة',
    'please-select-material': 'يرجى اختيار مادة',
}